import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useUIStore } from '../store';

export function LinkedRolesCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showToast } = useUIStore();

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      showToast('Failed to link Discord role connection', 'error');
      navigate('/');
      return;
    }

    if (code) {
      // Redirect to the API to complete the flow
      const apiUrl = import.meta.env.VITE_API_URL || '/api';
      window.location.href = `${apiUrl}/linked-roles/callback?code=${code}`;
      return;
    }

    // Check URL params for success/error from API redirect
    const linkedRoles = new URLSearchParams(window.location.search).get('linked_roles');
    if (linkedRoles === 'success') {
      showToast('Discord role connection linked successfully!', 'success');
    }

    navigate('/');
  }, [searchParams, navigate, showToast]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-foretell-accent" />
        <p className="text-slate-400">Linking Discord role connection...</p>
      </div>
    </div>
  );
}
